<template>
  <div class="my-body">
    <div class="content">
      <div class="left">
        <img src="/static/logo.png" class="logo" alt="" />
        <div class="login-img">
          <img src="/static/login_img.png" alt="" />
        </div>
      </div>
      <div v-if="!forget" class="right">
        <span class="title1">欢迎登录</span>
        <span class="title2">儿童医疗救助平台</span>
<!--        <span class="title3">医院登录入口</span>-->
        <div class="form">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item prop="psnAccount">
              <div class="item">
                <span>账号</span>
                <input
                  type="text"
                  placeholder="请输入账号名"
                  @input="errAcc=false"
                  v-model="form.psnAccount"
                />
              </div>
            </el-form-item>
            <div class="err" v-if="errAcc">
              <img src="/static/err-icon.png" alt="" />
              <span>该账号不存在</span>
            </div>
            <el-form-item prop="psnPassword">
              <div class="item">
                <span>密码</span>
                <input
                  type="password"
                  placeholder="请输入密码"
                  @input="errPas=false"
                  v-model="form.psnPassword"
                />
              </div>
            </el-form-item>
            <div class="err" v-if="errPas">
              <img src="/static/err-icon.png" alt="" />
              <span>密码错误，请重新输入</span>
            </div>
          </el-form>
        </div>
        <div class="login" @click="login">登录</div>
        <div class="others">
          <div class="rem" @click="rememberClick">
            <img v-if="!remember" src="/static/checkbox.png" alt="" />
            <img v-if="remember" src="/static/checkbox-in.png" alt="" />
            <span>记住密码</span>
          </div>

          <!-- <span @click="forgetClick">忘记密码？</span> -->
        </div>
      </div>
      <div v-if="forget" class="right">
        <span class="title1">{{
          step == 1 ? "验证账号" : "重新设置密码"
        }}</span>
        <span class="title4"
          >已有账号，<span @click="loginNow">马上登录</span></span
        >
        <div v-if="step == 1" class="form">
          <div class="item">
            <span>手机号</span>
            <input
              type="text"
              v-model="forgetPhone"
              placeholder="请输入手机号"
            />
          </div>
          <div class="item">
            <span></span>
            <input type="text" placeholder="请输入验证码" />
            <!--            <MsgCodeInput  @msgCodeValue="msgCodeValue" :tel="forgetPhone"></MsgCodeInput>-->
            <div v-if="!getingCode" @click="getCode" class="getCode">
              {{ btnText }}
            </div>
            <!--            <div v-if="getingCode" class="geting">59s后重发</div>-->
          </div>
        </div>
        <div v-if="step == 2" class="form">
          <div class="item">
            <span>新密码</span>
            <input type="password" placeholder="请输入新密码" />
          </div>
          <div class="item">
            <span>需确认</span>
            <input type="password" placeholder="请再次输入新密码" />
          </div>
        </div>
        <div class="login" @click="nextClick">
          {{ step == 1 ? "下一步" : "完成" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, sendCaptchaApi } from "./../util/api";
import MsgCodeInput from "../components/business/MsgCodeInput";
import sha256 from 'crypto-js/sha256';
export default {
  components: {
    MsgCodeInput,
  },
  name: "login",
  data() {
    return {
      forgetPhone: "",
      msgCodeValue: "",
      remember: false,
      forget: false,
      getingCode: true,
      btnText: "获取验证码",
      count: 60,
      errAcc:false,
      errPas:false,
      timeInterval: null,
      step: 2,
      form: {
        psnAccount: "",
        psnPassword: "",
      },
      rules: {
        psnAccount: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        psnPassword: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    document.title = "爱佑慈善基金会";
    this.form.psnAccount = window.localStorage.getItem("psnAccount") || "";
    this.form.psnPassword = window.localStorage.getItem("psnPassword") || "";
  },
  mounted() {
    let self = this;
    document.onkeydown = function (e) {
      let ev = document.all ? window.event : e;
      if (ev.keyCode === 13) {
        self.login();
      }
    };
  },
  watch: {
    remember(newValue, oldValue) {
      if (newValue) {
        window.localStorage.setItem("psnAccount", this.form.psnAccount);
        window.localStorage.setItem("psnPassword", this.form.psnPassword);
      } else {
        window.localStorage.removeItem("psnAccount");
        window.localStorage.removeItem("psnPassword");
      }
    },
  },
  methods: {
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const encryptedPassword = sha256(this.form.psnPassword).toString();
          const encryptedAccount = sha256(this.form.psnAccount).toString();
          let param = {
            psnAccount: encryptedAccount,
            psnPassword: encryptedPassword,
          };
          login(param)
            .then((res) => {
              if (res.msgCode == 200) {
                if (res.responseData.token)
                  window.localStorage.setItem("token", res.responseData.token);
                  window.localStorage.setItem("psnAccountShow", res.responseData.psnAccount);
                var hospAccount = false;
                for (var i = 0; i < res.responseData.accountRoles.length; i++) {
                  if (
                    res.responseData.accountRoles[i].roleCode.indexOf(
                      "cm_hospital"
                    ) !== -1
                  ) {
                    hospAccount = true;
                  }
                }
                window.localStorage.setItem("hospAccount", hospAccount);
                this.$router.push("/home");
              }else if (res.msgCode == 510) {
                this.$message.error(res.msg);
              } else {
                // errAcc
                // errPas
                if(res.msg=='用户不存在') this.errAcc = true
                if(res.msg=='用户名或密码错误') this.errPas = true
                // this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    rememberClick() {
      this.remember = !this.remember;
    },
    forgetClick() {
      this.step = 1;
      this.forget = true;
      this.getingCode = false;
    },
    loginNow() {
      this.forget = false;
    },
    checkPhone() {
      if (!this.forgetPhone) {
        return false;
      } else {
        var p = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
        if (!p.test(this.forgetPhone)) {
          return false;
        }
      }
      return true;
    },
    getCode() {
      if (!this.checkPhone()) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      let param = {
        phone: this.forgetPhone,
      };
      if (this.getingCode) return;
      this.getingCode = true;
      sendCaptchaApi(param).then((res) => {
        if (res.msgCode == 200) {
          console.log(res.responseData);
          this.$message.success("发送成功，请注意查收");

          this.btnText = this.count + "s后重新发送";
          this.timeInterval = setInterval(() => {
            this.count--;
            this.btnText = this.count + "s后重新发送";
          }, 1000);
          setTimeout(() => {
            clearInterval(this.timeInterval);
            this.btnText = "获取验证码";
            this.count = 60;
            this.getingCode = false;
          }, 60000);
        } else {
          this.$message.error(res.msg);
          this.getingCode = false;
        }
      });
    },
    nextClick() {
      if (this.step == 1) {
        this.step = 2;
      } else {
        this.loginNow();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-body {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 8.125vw;
  height: calc(31.04vw + 3.54vw + 3.28vw);
  .logo {
    width: 17.03vw;
    height: 4.323vw;
  }

  .login-img {
    width: 32.8vw;
    height: 21.875vw;

    img {
      width: 100%;
      height: 100%;
      margin-top: 1.04vw;
    }
  }
}

.right {
  width: 16.77vw;
  height: 31.04vw;
  background: #ffffff;
  box-shadow: 0px 0.7vw 2.55vw 0px rgba(255, 69, 97, 0.14);
  border-radius: 0.625vw;
  padding: 3.54vw 3.43vw 3.28vw 3.43vw;

  .title1 {
    font-size: 1.875vw;
    display: block;
    color: #333333;
    font-family: PingFang SC;
    font-weight: 400;

    color: #666666;
  }

  .title2 {
    font-size: 1.875vw;
    display: block;
    font-family: PingFang SC;
    color: #333333;
    line-height: 44px;
    display: block;
    margin-top: 0.5vw;
    font-weight: 800;
  }

  .title3 {
    font-size: 0.833vw;
    display: block;
    font-family: PingFangSC;
    font-weight: 400;
    color: #999999;
    line-height: 2.813vw;
    letter-spacing: 1.198vw;
  }

  .title4 {
    font-size: 0.833vw;
    display: block;
    font-family: PingFangSC;
    font-weight: 400;
    color: #999999;
    line-height: 2.813vw;

    span {
      cursor: pointer;
      color: #ff4661;
    }
  }

  .form {
    margin-top: 3.645vw;

    .err {
      display: flex;
      align-items: center;
      float: right;
      font-size: 0.729vw;
      font-family: PingFangSC;
      font-weight: 400;
      color: #DF062F;
      margin-top: -10px;
      img {
        width: 0.729vw;
        height: 0.729vw;
        margin-right: 0.208vw;
      }
    }

    .item {
      margin-top: 2.083vw;
      width: 100%;
      border-bottom: #e2e2e2 0.052vw solid;
      display: flex;
      align-items: center;
      height: 2.083vw;

      .getCode {
        width: 4.688vw;
        height: 1.875vw;
        background: #df062f;
        border-radius: 0.313vw;
        font-size: 0.7vw;
        font-family: PingFangSC;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.875vw;
        text-align: center;
      }

      .geting {
        width: 4.688vw;
        height: 1.875vw;
        background: #898989;
        border-radius: 0.313vw;
        font-size: 0.7vw;
        font-family: PingFangSC;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.875vw;
        text-align: center;
      }

      span {
        font-size: 0.93vw;
        font-family: PingFangSC;
        font-weight: 400;
        color: #333333;
        flex-shrink: 0;
      }

      input {
        width: 8.208vw;
        font-size: 0.93vw;
        font-family: PingFangSC;
        font-weight: 400;
        // color: #adadad;
        margin-left: 1.04vw;
        border: none;
        outline: none;
      }
    }
  }

  .login {
    width: 16.771vw;
    height: 3.125vw;
    background: linear-gradient(180deg, #ff173d, #dc243e);
    border-radius: 0.313vw;
    margin-top: 4.323vw;
    text-align: center;
    line-height: 3.125vw;
    font-size: 1.042vw;
    font-family: PingFangSC;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }

  .login:hover {
    background: linear-gradient(180deg, #ff173d, #dc243e);
  }

  .others {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 0.885vw;
    font-size: 0.729vw;
    font-family: PingFangSC;
    font-weight: 400;
    color: #666666;

    .rem {
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 30px;
      img {
        width: 0.729vw;
        height: 0.729vw;
        margin-right: 0.26vw;
      }
    }

    span {
      line-height: 2.813vw;
      cursor: pointer;

      input {
        margin: 0.313vw 0.26vw 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue